import Cookies from 'js-cookie';

const handler = ( $ ) => {
	// Tabs for events
	const tabsInit = () => {
		const $tabs = $( '.page-events__tabs' );
		const $tabItems = $tabs.find( '.page-events__tabs-item' );
		const $tabLinks = $tabItems.find( '[role="tab"]' );
		const $tabPanels = $tabs.find( '[role="tabpanel"]' );

		// Hide all panels except the first one
		$tabPanels.hide().eq( 0 ).show();
		$tabItems.eq( 0 ).addClass( 'is-active' );

		$tabLinks.on( 'click', function ( e ) {
			e.preventDefault();
			const $link = $( this );
			const $item = $link.parents( '.page-events__tabs-item' );
			const targetId = $link.attr( 'href' );

			// Update tabs state
			$tabItems.removeClass( 'is-active' );
			$item.addClass( 'is-active' );

			// Show selected panel
			$tabPanels.hide();
			$( targetId ).show();
		} );
	};

	// Filter past events
	const filterPastEventInit = () => {
		const $list = $( '#tabs-2 .page-events__events-list' );
		const $loadMore = $( '#tabs-2 .page-events__load-more' );

		const selectChangeHandler = function () {
			const $select = $( this );
			const category = $select.val();
			const eventsPerPage = $select.data( 'events-per-page' );
			console.log( 'category', category );

			$.ajax( {
				url: themeVars.ajaxurl,
				type: 'POST',
				data: {
					action: 'fp_filter_past_events',
					category: category,
					events_per_page: eventsPerPage,
					page: 1,
					nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
				},
				beforeSend: function () {
					$list.addClass( 'is-loading' );
				},
				success: function ( response ) {
					if ( response.success ) {
						$list.html( response.data.html );

						if ( response.data.max_pages > 1 ) {
							$loadMore
								.data( 'events-per-page', eventsPerPage )
								.data( 'page', 1 )
								.data( 'category', category )
								.show();
						} else {
							$loadMore.hide();
						}
					}
				},
				complete: function () {
					$list.removeClass( 'is-loading' );
				},
			} );
		};

		$( '.page-events__filter-select' ).on( 'change', selectChangeHandler );
	};

	// Load more events
	const loadMoreEventsInit = () => {
		const loadMoreClickHandler = function () {
			const $button = $( this );
			const $list = $button.siblings( '.page-events__events-list' );
			const buttonText = $button.text();
			const page = parseInt( $button.data( 'page' ) ) + 1;
			const type = $button.data( 'type' );
			const eventsPerPage = $button.data( 'events-per-page' );
			const category = $button.data( 'category' );

			$.ajax( {
				url: themeVars.ajaxurl,
				type: 'POST',
				data: {
					action: 'fp_load_more_events',
					page: page,
					type: type,
					events_per_page: eventsPerPage,
					category: category,
					nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
				},
				beforeSend: function () {
					$button
						.text( 'Loading...' )
						.addClass( 'is-loading' )
						.prop( 'disabled', true );

					$list.addClass( 'is-loading' );
				},
				success: function ( response ) {
					if ( response.success ) {
						$list.append( response.data.html );
						$button.data( 'page', page ).show();

						if ( page >= response.data.max_pages ) {
							$button.hide();
						}
					}
				},
				complete: function () {
					$button
						.text( buttonText )
						.removeClass( 'is-loading' )
						.prop( 'disabled', false );

					$list.removeClass( 'is-loading' );
				},
			} );
		};

		$( document ).on(
			'click',
			'.page-events__load-more',
			loadMoreClickHandler
		);
	};

	tabsInit();
	filterPastEventInit();
	loadMoreEventsInit();
};

export default ( ( $ ) => $( handler ) )( jQuery );
